import React, { useEffect, useLayoutEffect } from "react";
import { Route, Switch, Router, Redirect, useLocation } from "react-router-dom";
import Dashboard from "../Dashboard";
import Header from "../../components/Header";
import STD from "../Std";
import Footer from "../../components/Footer";
import Login from "../Login";
// import PasswordExpiry from "../Login/PasswordExpiry";
import history from "../../utilities/history";
import UserProfile from "../UserProfile";
import AccountSetting from "../AccountSetting";
import Settings from "../Settings";
import * as commonActions from "../../redux/actions/commonAction";
import { useDispatch, useSelector } from "react-redux";
import { bindActionCreators } from "redux";
import Attachments from "../Attachments";
import ErsApplicant from "../ErsApplicant";
import { TOKEN_KEY, EXCEPTIONALURL } from "../../App.config";
import AllCaseDetails from "../AllCaseDetails";
import Air from "../Air";
import * as modalActions from "../../redux/actions/modalActions";
import * as authActions from "../../redux/actions/userAuthAction";
import * as notificationActions from "../../redux/actions/notificationAction";
import CompanySetup from "../Company";
import AirApplicant from "../AirApplicant";
import CurrentActivity from "../CurrentActivity"
import Accomodation from "../Accomodation";
import AccomodationApplicant from "../AccomodationApplicant";
import FileUploads from "../FileUploads";
import SetUrlComponent from '../SetReferenceUrl'
import BackupUserComponent from '../BackupUser'
import UserForm from "../UserForm";
import UserList from "../UserList"
import ForPendingServices from "../ForPendingServicesPages";
import MyApplications from "../MyApplications";
import PropTypes from "prop-types";
import ReportPage from "../Report";
import ViewReports from "../../components/Report/ViewReports";
import DemoReport from "../Report/DemoReport";
import MyReport from "../Report/MyReport";
import CCMPage from "../CCM/index";

// import DataTable from "../../components/Datatable"

const Home = (props, context) => {
  const location = useLocation();
  const dispatch = useDispatch();

  const profileReducer = useSelector((state) => state.profileReducer);
  const modalAction = bindActionCreators(modalActions, dispatch);
  const commonReducer = useSelector((state) => state.commonReducer);
  const commonAction = bindActionCreators(commonActions, dispatch);
  let authAction = bindActionCreators(authActions, dispatch);
  let notificationAction = bindActionCreators(notificationActions, dispatch);

  const closeRemoveModal = () => {
    modalAction.closeRemoveModal();
  };

  //On route change verify token
  useEffect(() => {
    if (!localStorage.getItem(TOKEN_KEY)) {
      history.push("/");
    }
    else {
      authAction.getUserRolePermissions();
      authAction.getUserCompanyServices();
      // authAction.getAuthUserRoles();

      notificationAction.resetNotificationShown();
    }

    commonAction.setIsSideMenuOpen(true);

    return () => {
      if (!EXCEPTIONALURL.includes(window.location.hash)) {
        closeRemoveModal();
      }
    };


  }, [location]);

  return (
    <Router history={history}>
      <section
        className={
          commonReducer.isSideMenuOpen
            ? "Dashboard-container"
            : "Dashboard-container open"
        }
      >
        <div className="Content-Container">
          {window.location.hash !== "#/" && (
            <Header context={context} managersDetails={profileReducer.managersDetails} />
          )}
          <Switch>
            <Route path="/" exact component={Login} />
            {/* <Route path="/setExpiryPassword" exact component={PasswordExpiry} /> */}
            {/* <div className="Content-Panel"> */}
            <Route path="/dashboard" exact component={Dashboard} />
            <Route path="/settings" exact component={AccountSetting} />
            {/* <Route path="/login" exact component={Login} />  */}
            <Route path="/STD" exact component={STD} />
            <Route path="/mysettings" exact component={Settings} />
            <Route path="/profile" exact component={UserProfile} />
            {/* <Route path="/user-form" exact component={UserForm} /> */}
            <Route path="/add-user-form" exact component={UserForm} />
            <Route path="/update-user-form" exact component={UserForm} />
            <Route path="/user-list" exact component={UserList} />
            <Route path="/attachments" exact component={Attachments} />
            <Route path="/allcasedetails" exact component={AllCaseDetails} />
            <Route path="/applicants" exact component={ErsApplicant} />
            <Route path="/company" exact component={CompanySetup} />
            <Route path="/air" exact component={Air} />
            <Route path="/accomodation" exact component={Accomodation} />
            <Route path="/ccm" exact component={CCMPage} />
            <Route path="/airapplicant" exact component={AirApplicant} />
            <Route path="/acmdapplicant" exact component={AccomodationApplicant} />
            <Route path="/currentactivity" exact component={CurrentActivity} />
            <Route path="/file-uploads" exact component={FileUploads} />
            <Route path="/back-up-user" exact component={BackupUserComponent} />
            <Route path="/refURL" component={SetUrlComponent} />
            <Route path="/forPendingServices" component={ForPendingServices} />
            <Route path="/forPendingServices1" component={ForPendingServices} />
            <Route path="/forPendingServices2" component={ForPendingServices} />
            <Route path="/report" exact component={ReportPage} />
            <Route path="/viewreport" exact component={ViewReports} />
            <Route path="/myApplications" component={MyApplications} />
            <Route path="/demoreport" component={DemoReport} />
            <Route path="/myreport" component={MyReport} />
            {/* <Route path="/data-table" component={DataTable} /> */}
            <Route render={() => <Redirect to="/" />} />
            {/* </div> */}
          </Switch>
          <Footer />
        </div>
      </section>
    </Router>
  );
};

Home.contextTypes = {
  t: PropTypes.func.isRequired,
};

export default Home;
